// extracted by mini-css-extract-plugin
export default {"Box":"SubIssueRemovedEvent-module__Box__r4hvI0S","Box_1":"SubIssueRemovedEvent-module__Box_1__OkfmaUI"};